<script lang="ts">
	import LegalSection from '$lib/components/legal/legal-section.svelte';

	const { children } = $props();
</script>

<LegalSection>
	{@render children?.()}
</LegalSection>
